import React, { useMemo } from "react";
import styles from "./FloatingPanel.module.css";
import { mcn } from "../../../utils/mergeClassnames.js";
let n = 0;
const FloatingPanel = (props) => {
    const zIndex = useMemo(() => {
        if (n === 199) {
            n = 0;
        }
        return 200 + n++;
    }, []);
    const position = props.align === "top" ? { top: "0" } : { bottom: "0" };
    if (props.fixed) {
        const ELASTIC_SCROLL_GAP = 100;
        Object.assign(position, {
            position: "fixed",
            paddingBottom: ELASTIC_SCROLL_GAP,
            marginBottom: -ELASTIC_SCROLL_GAP,
            zIndex
        });
    }
    return (React.createElement("div", { ...props.attributes, className: mcn(styles.floatingPanel, props.sticky && styles.sticky, props.className, "floating-panel"), style: { ...position, ...props.style } }, props.children));
};
export default FloatingPanel;
